// removed by extract-text-webpack-plugin
module.exports = {"anchor":"summary__anchor___2JCJr"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/skin/styles/list/summary.css
// module id = 1238
// module chunks = 0